// anystring@anystring.anystring
export const emailRegex = /\S+@\S+\.\S+/;

// Minimum eight characters, at least one letter and one number
// const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/; 

// Minimum eight characters, at least one capital letter, number and special character
export const passwordRegex = /^((?=.*\d)(?=.*[A-Z])(?=.*?[a-z])(?=.*\W).{8,})$/;

// only digits
export const phoneRegex = /^[0-9]+$/;

// supported formats gif, jpg, jpeg, png
export const imageRegex = /.*\.(gif|jpe?g|png)$/i;